module.exports = __webpack_public_path__ + "img/check.de5a06e4.svg";